import script from "./ModalModificarPairingEquipos.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalModificarPairingEquipos.vue?vue&type=script&setup=true&lang=ts"

import "./ModalModificarPairingEquipos.vue?vue&type=style&index=0&id=3946ec37&lang=css"

const __exports__ = script;

export default __exports__